import React from 'react';

export default function Map(){
  return(
    <iframe title="Map to the Beauty Shop" className ="Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1631.745220310432!2d-89.99189467856954!3d35.11943277382315!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x887f8751d83ccd11%3A0xf3952956cf7d4926!2sThe%20Beauty%20Shop!5e0!3m2!1sen!2sus!4v1610214971702!5m2!1sen!2sus"></iframe>  
  )
}